import { ViewStream } from "spyne";
import { UIMenuDrawer } from "components/ui/ui-menu-drawer";
import { UIModalWindowContainer } from "components/ui/ui-modal-window-container";

export class UIMainView extends ViewStream {
  constructor(props = {}) {
    props.id = "app-ui";
    props["aria-label"] = "mylabel";
    props["my-ubu"] = "mytest";
    props.template = require("./templates/ui-main.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_APP_API_RESPONSE_EVENT", "onChannelAppDataEvent"],
      ["CHANNEL_SPYNE_DOCS_DATA_LOADED_EVENT", "onDocsDataLoadedEvent"],
    ];
  }

  onDocsDataLoadedEvent(e) {
    const { payload } = e;

    const { modals } = payload.codeGenData;
    const data = modals;
    this.appendView(new UIModalWindowContainer({ data }));
  }

  onChannelAppDataEvent(e) {
    const { payload } = e;
    this.addUIELements(payload);
  }

  addUIELements(data) {
    this.appendView(new UIMenuDrawer({ data }));
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    this.addChannel("CHANNEL_APP_API");
    this.addChannel("CHANNEL_SPYNE_DOCS_DATA");
  }
}
